import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logoutUser, loadUser, seeNotice } from './actions';
import Notice from '../../components/Notification/newNotification';

class AuthWrapper extends Component {
    componentDidMount() {
        this.props.loadUser();
    }

    render() {
        const {children} = this.props;
        const childrenWithProps = React.Children.map(
            children,
            child => React.cloneElement(
                child,
                {
                    onLogout: this.props.logout,
                    auth: this.props.auth,
                    seeNotice: (data, userData) => this.props.seeNotice(data, userData)
                }
            )
        );
        return <div>{childrenWithProps}<Notice /></div>;
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(logoutUser()),
        loadUser: () => dispatch(loadUser()),
        seeNotice: (data, userData) => dispatch(seeNotice(data, userData))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapper);



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/index.js